// extracted by mini-css-extract-plugin
export default {"container":"aut_2f6rJ","label":"aut_lab_1HA9C","initials":"aut_ini_3Gq1V","role":"aut_rol_3_9uq","thumbnail":"aut_thu_1OIo3","title":"aut_tit_2bSM7","withBorder":"aut_wit_3k9AB"};